module.exports = __webpack_public_path__ + "static/hero-eccd769d1785f53a313047b018dd2909.jpg";